import ProductGender from './productGender';

export default ProductGender;
